<template>
  <div>
    <div class="banner">
      <img src="/static/images/banner-contactus.png">
    </div>
    <div class="box">
      <div class="title">联系我们</div>
      <span class="title-line"></span>
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="contact el-row--flex">
          <div>
            <img src="/static/images/icon/icon-phone.png" >
          </div>
          <div>
            <div class="contact-label">电话：</div>
            <div class="contact-content">0571-8381-7082</div>
          </div>
        </div>
        <div class="contact el-row--flex">
          <div>
            <img src="/static/images/icon/icon-email.png" >
          </div>
          <div>
            <div class="contact-label">邮箱：</div>
            <div class="contact-content">adm@cywy56.com</div>
          </div>
        </div>
        <div class="contact el-row--flex">
          <div>
            <img src="/static/images/icon/icon-address.png" >
          </div>
          <div>
            <div class="contact-label">地址：</div>
            <div class="contact-content">浙江省杭州市萧山区市心北路108号</div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-box bgf5">
      <div class="width1200 el-row--flex is-justify-center">
        <div class="map">
          <amap
            :zoom="19"
            view-mode="3D"
            async=""
            :center="center"
          >
            <amap-marker
              :position="center"
              icon="/static/images/icon/icon-map-marker.png"
              :label="labelObj"
            ></amap-marker>
          </amap>
        </div>
        <div class="map-content">
          <div class="map-content-title">联系我们</div>
          <div class="map-content-label">
            电话：
            <span class="map-content-label-phone">0571-8381-7082</span>
          </div>
          <div class="map-content-label">
            邮件：
            <span>adm@cywy56.com</span>
          </div>
          <div class="map-content-label">
            地址：
            <span>浙江省杭州市萧山区市心北路108号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        center: [120.268663, 30.202519],
        labelObj: {
          content: "杭州晟易网络技术服务有限公司<div>浙江省杭州市萧山区市心北路108号5005D室</div>",
          offset: [110, -60],
          direction: "center"
        }
      }
    }
  }
</script>

<style lang="scss">
  .title-line {
    display: inline-block;
    width: 40px;
    height: 4px;
    margin-top: 30px;
    background-color: #0b5bdc;
  }

  .contact {
    margin-top: 95px;
    margin-bottom: 88px;
    text-align: left;

    img {
      margin-top: 5px;
      margin-right: 15px;
    }

    &-label {
      font-size: 24px;
      color: #1875f0;
    }

    &-content {
      margin-top: 10px;
      font-size: 20px;
      color: #333;
    }
  }

  .map-box {
    padding: 100px 0 86px;

    .map {
      width: 767px;
      height: 463px;
      margin-right: 90px;

      .amap-icon img {
        position: inherit;
      }

      .amap-marker-label {
        width: 345px;
        height: 129px;
        padding-top: 35px;
        padding-left: 34px;
        border: none;
        background-color: transparent;
        background-image: url(/static/images/bg-map-label.png);
        background-size: cover;
        font-size: 18px;
        color: #333;
        text-align: left;
        box-sizing: border-box;

        div {
          margin-top: 15px;
          font-size: 14px;
          color: #333;
        }
      }
    }

    .map-content {
      text-align: left;

      &-title {
        margin-top: 55px;
        margin-bottom: 40px;
        font-size: 22px;
        color: #333;
      }

      &-label {
        margin-top: 17px;
        font-size: 18px;
        font-weight: 500;
        color: #333;

        span {
          font-weight: 400;
        }

        &-phone {
          font-weight: 700;
          color: #1875f0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/contactus.vue